$(document).ready(function() {
    $('body').on('change', '.filter-form select, .filter-form input', function() {
        $(this).closest('.filter-form').submit();
    });
});